import React, { Component } from "react";
import "../../Styles/Admin.scss";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

import userConfig from './userConfig.json'

class UserRole extends Component {

  render() {
    return (
      <div className="UserAccessCont">
          <div className="userConfig">
            <h4>Select User Configuration</h4>
            <div className="ucBox">
              <div className=" tblCont dataGrids ">
                <div className="rw-tab-content">
                  <Grid data={[...userConfig]}>
                    <Column field="Role" title="Role" />
                    <Column  
                      title="Home" 
                      cell = {props => (
                       
                          props.dataItem.Role == 'Admin' ? 
                            <td></td>
                          :
                            <td>
                            <select>
                              <option>Full</option>
                              <option>View Only</option>
                              <option>No</option>
                            </select>
                            </td>
                          
                        
                       
                      )}
                    />
                    <Column  title="Risks" 
                      cell = {props => (
                        props.dataItem.Role == 'Admin' ? 
                            <td></td>
                          :
                            <td>
                            <select>
                              <option>Full</option>
                              <option>View Only</option>
                              <option>No</option>
                            </select>
                            </td>
                          
                        
                      )}
                    />
                    <Column  title="Action" 
                      cell = {props => (
                        props.dataItem.Role == 'Admin' ? 
                            <td></td>
                          :
                            <td>
                            <select>
                              <option>Full</option>
                              <option>View Only</option>
                              <option>No</option>
                            </select>
                            </td>
                          
                        
                      )}
                    />
                    <Column  title="Reports" 
                      cell = {props => (
                        props.dataItem.Role == 'Admin' ? 
                        <td></td>
                      :
                        <td>
                        <select>
                          <option>Full</option>
                          <option>View Only</option>
                          <option>No</option>
                        </select>
                        </td>
                      
                    
                      )}
                    />
                    <Column  title="Analytics" 
                      cell = {props => (
                        props.dataItem.Role == 'Admin' ? 
                            <td></td>
                          :
                            <td>
                            <select>
                              <option>Full</option>
                              <option>View Only</option>
                              <option>No</option>
                            </select>
                            </td>
                          
                        
                      )}
                    />
                    <Column  title="Scenarios" 
                      cell = {props => (
                        props.dataItem.Role == 'Admin' ? 
                        <td></td>
                      :
                        <td>
                        <select>
                          <option>Full</option>
                          <option>View Only</option>
                          <option>No</option>
                        </select>
                        </td>
                      
                    
                      )}
                    />
                    <Column  title="Admin" 
                      cell = {props => (
                        props.dataItem.Role == 'Admin' ? 
                            <td></td>
                          :
                            <td>
                            <select>
                              <option>Full</option>
                              <option>View Only</option>
                              <option selected>No</option>
                            </select>
                            </td>
                          
                        
                      )}
                    />
                  </Grid>
                </div>
              </div>
            </div>
          </div>

      </div>
    )
  }
}
export default UserRole
